import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { OrganizationSettingsWidget } from '../../../lib/organization-settings-widget'

export type SettingsPageProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export const SettingsPage = React.memo(function SettingsPage({
    className,
    style,
}: SettingsPageProps): React.ReactElement {
    return (
        <PageLayoutContainer className={cn(className)} style={style}>
            <OrganizationSettingsWidget />
        </PageLayoutContainer>
    )
})
